import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { Utility } from '../../core/interceptor/utility';
import { Note } from '../models/note.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  constructor(private http: HttpService) {}

  getNotes(userId: number): Observable<Note[]> {
    return this.http.request('get', '/v1/admin/note?user_id=' + userId).pipe(
      map((response: any) => response.data),
      map((notes: any[]) =>
        notes.map((serverNote) => {
          const note = Utility.camelize(serverNote);
          note.adminUser = Utility.camelize(note.adminUser);
          return note as Note;
        })
      )
    );
  }

  saveNote(note: Note): Observable<any> {
    return this.http.request('post', '/v1/admin/note', note);
  }
}
